/*
 * @Author:
 * @Date:
 * @Last Modified by: murphy.meng
 * @Last Modified time: 2020-11-27 11:19:13
 */

import configAuth from "../../configuration/configAuth.json";
import { browserHistory } from "react-router";
import { postLoginOut } from "./BLL";
import globalToast from "./globalToast";
import { Base64 } from "js-base64";

const BASEKEY = 'x0DE7'
function encodeToBase64(str) {
  return Base64.btoa(encodeURI(encodeURIComponent(str)));
}
  
export function SetKeyToBase64(key) {
  // if (!window) return key;
  if (!key) return key;
  // let str = key.replace(/ /g, '+')
  let basestr = encodeToBase64(key)
  return BASEKEY + basestr
}


export function decodeFromBase64(base64Str_x0) {
  if (typeof base64Str_x0 !== 'string') {
    return base64Str_x0;
  }
  if( base64Str_x0.slice(0, BASEKEY.length) != BASEKEY){
    return base64Str_x0
  }
  const base64Str = base64Str_x0.slice(BASEKEY.length, base64Str_x0.length)
  try {
    const str = decodeURIComponent(decodeURI(Base64.atob(base64Str)));
    if(str && /^[\u{0020}-\u{D7FF}\u{E000}-\u{FFFF}]*$/u.test(str)){
        return str
    }else {
        return base64Str
    }
  } catch (e) {
   // 解码失败，返回原始字符串
   return base64Str;
  }
}

export function myBrowser() {
  if (!-[1]) {
    if (console) {
      console.log("<=IE8");
    }
    return true;
  }
}
/**
 * 用来校验传入的url 是否配置 track code
 * @param {string} url 后台传入的url
 * zoneTian
 */
export function check_campaign_code(url) {
  return /intcmp=|kwrec=|prodlink=/.test(url);
}
export function CheckCampaignCode(link, omniture) {
  if (/intcmp=|kwrec=|prodlink=/.test(link)) {
    return link;
  }
  if (!omniture || omniture === "") {
    return link;
  }
  let hashNum = "";
  let query = link.split("?")[1] || null;
  let omni = omniture.split("?")[1] || omniture.split("?")[0];
  omni = omni.split("&")[1] || omni.split("&")[0];
  let domain = link.split("?")[0];
  if (/#/.test(link) || /#/.test(omniture)) {
    const linkHash = link.split("#")[1] || "";
    const omnitureHash = omniture.split("#")[1] || "";
    domain = domain.split("#")[0];
    hashNum =
      linkHash && omnitureHash ? `#${linkHash}&${omnitureHash}` : `#${linkHash}${omnitureHash}`;
    query = (link.match(/\?(\S*)\#/) && link.match(/\?(\S*)\#/)[1]) || null;
  }
  return query ? `${domain}?${query}&${omni}${hashNum}` : `${domain}?${omni}${hashNum}`;
}
export function GetEnv(title) {
  switch (title) {
    case "node":
      return JSON.parse(process.env.GlobalEnv)["localhost"][title];
    case "browser":
      return window.__INITIAL_ENV__["localhost"][title];
  }
}
export function GetEnvLocalhost(title) {
  switch (title) {
    case "node":
      return JSON.parse(process.env.GlobalEnv)["localhost"];
    case "browser":
      return window.__INITIAL_ENV__["localhost"];
  }
}
export function GetEnvValue(title, values, protocol) {
  switch (title) {
    case "node":
      if (protocol === "https") {
        return JSON.parse(process.env.GlobalEnv)[values].replace("http", "https");
      } else {
        return JSON.parse(process.env.GlobalEnv)[values];
      }
    case "browser":
      if (protocol === "https") {
        return window.__INITIAL_ENV__[values].replace("http", "https");
      } else {
        return window.__INITIAL_ENV__[values];
      }
  }
}

export function soaLoginOff() {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  document.cookie = "UID=; expires=" + exp.toGMTString() + "; path=/";
  document.cookie = "Token=; expires=" + exp.toGMTString() + "; path=/" + "; domain=.sephora.cn";
  location.href = "/";
}

export function loginOff(callback) {
  var wcsLoginState = GetSingleCookie("user_name");

  if (wcsLoginState) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    document.cookie = "WC_LOGINSTART=; expires=" + exp.toGMTString() + "; path=/";
    document.cookie = "WC_WC=; expires=" + exp.toGMTString() + "; path=/";
    document.cookie = "WC_EMAIL=; expires=" + exp.toGMTString() + "; path=/";
    document.cookie = "UID=; expires=" + exp.toGMTString() + "; path=/";
    document.cookie = "Token=; expires=" + exp.toGMTString() + "; path=/";

    document.cookie = "user_name=; domain=.sephora.cn; expires=" + exp.toGMTString() + "; path=/";
    document.cookie = "user_id=; domain=.sephora.cn; expires=" + exp.toGMTString() + "; path=/";
  }

  location.href =
    "/webapp/wcs/stores/servlet/Logoff?catalogId=10052&langId=-7&storeId=10001&URL=TopCategoriesDisplayView";
  var expiresDate = new Date();
  expiresDate.setTime(expiresDate.getTime() + 90 * 24 * 60 * 60 * 1000);
  $.cookie("orderItem", "", { path: "/", expires: expiresDate });
  callback();
}
export function loginOut() {
  const data = {
    channel: "WEB",
  };
  try {
    postLoginOut(data, () => {
      soaLoginOff();
    });
  } catch (error) {
    soaLoginOff();
  }
}
export function GetSingleCookieMatch(cookies) {
  let returnCookie = null;
  if (!document.cookie) {
    return returnCookie;
  }
  document.cookie.split("; ").map((data, index) => {
    if (data.indexOf(cookies) > -1) {
      returnCookie = data;
    }
  });
  return returnCookie;
}

export function SetSingleCookie(documentCookies, cookie, value) {
  documentCookies = cookie + "=" + escape(value);
}

export function SetForeverCookie(cookie, value) {
  let Times = 60 * 24 * 365 * 20;
  let exp = new Date();
  exp.setTime(exp.getTime() + Times * 60 * 1000);
  window.document.cookie =
    cookie + "=" + escape(value) + ";expires=" + exp.toGMTString() + "; domain=.sephora.cn; path=/";
}

export function SetTimeCookie(cookie, value) {
  let Times = 30;
  let exp = new Date();
  exp.setTime(exp.getTime() + Times * 60 * 1000);
  window.document.cookie =
    cookie + "=" + escape(value) + ";expires=" + exp.toGMTString() + "; domain=.sephora.cn; path=/";
}

export function RecordOrderChannel() {
  let utm_source = browserHistory.getCurrentLocation().query.utm_source;
  let utm_medium = browserHistory.getCurrentLocation().query.utm_medium;
  let utm_campaign = browserHistory.getCurrentLocation().query.utm_campaign;
  let utm_content = browserHistory.getCurrentLocation().query.utm_content;
  let utm_term = browserHistory.getCurrentLocation().query.utm_term;
  if (utm_source || utm_medium || utm_campaign || utm_content || utm_term) {
    let j = {};
    j.utm_source = encodeURIComponent(utm_source);
    j.utm_medium = encodeURIComponent(utm_medium);
    j.utm_campaign = encodeURIComponent(utm_campaign);
    j.utm_content = encodeURIComponent(utm_content);
    j.utm_term = encodeURIComponent(utm_term);
    j.currentTime = moment().format("X");
    let stringjson = JSON.stringify(j);
    SetTimeCookie("order_source", stringjson);

    if (!$.cookie("first_touch_source")) {
      SetForeverCookie("first_touch_source", stringjson);
    }
  }
}

export function GetSingleCookie(documentCookies, cookie) {
  var arr = documentCookies.match(new RegExp("(^| )" + cookie + "=([^;]*)(;|$)"));
  if (arr != null) return unescape(arr[2]);
  return null;
}

export function GoogleTagManager(dataLayer) {
  window.dataLayer = [] = dataLayer;
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "//www.googletagmanager.com/gtm.js?id=" + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, "script", "dataLayer", "GTM-N57TLT");
}

/*
 * GoogleTagManager  Event
 * @param dataLayer window.dataLayer
 * @param parameter window.dataLayer.event
 * @constructor
 */
export function pushGoogleTagManager(parameter) {
  //console.log( window.dataLayer );
  //console.log( parameter );
  if (window.dataLayer) {
    window.dataLayer.push(parameter);
  }
}

export function GetNickName(value) {
  if (!value || value.split("@").length > 2) {
    return null;
  }
  return value.split("@")[0];
}

export function GetCookie(params, callback) {
  // prototype 设定默认CookieId 和 CookieToken
  //let relCookieID = 'ghost';
  let relCookieID = null;
  let relCookieToken = null;

  if (!params.Cookie) {
    // NO Cookie Callback Ghost
    return callback(relCookieID, relCookieToken);
  }

  if (GetSingleCookie(params.Cookie, "Token")) {
    relCookieToken = GetSingleCookie(params.Cookie, "Token");
  }

  if (GetSingleCookie(params.Cookie, "UID")) {
    relCookieID = GetSingleCookie(params.Cookie, "UID");
  }

  // NO match Callback Ghost
  return callback(relCookieID, relCookieToken);
}

export function GetClientCookie(params, callback) {
  let relCookieID = null;
  let relCookieToken = null;

  if (!params.Cookie) {
    // NO Cookie Callback Ghost
    return callback(relCookieID, relCookieToken);
  }

  if (GetSingleCookie(params.Cookie, "Token")) {
    relCookieToken = GetSingleCookie(params.Cookie, "Token");
  }

  if (GetSingleCookie(params.Cookie, "UID")) {
    relCookieID = GetSingleCookie(params.Cookie, "UID");
  }

  // NO match Callback Ghost
  return callback(relCookieID, relCookieToken);
}

export function isClient() {
  return typeof window !== "undefined" && window.document;
}

/**
 * A.如果API返回STATUS == 401 重定向到 登录页
 * B.如果路由在安全区，并且无Token 重定向到 登录页
 * @param json
 * @returns {*}
 * @constructor
 *
 */
export function GetConfirmation(json) {
  let _AuthList = configAuth.url,
    _AuthUser = configAuth.user,
    _PathName = window.location.pathname,
    _Token = GetSingleCookie(window.document.cookie, "Token"),
    ajaxOptions = json.ajaxOptions,
    tpId = GetSingleCookie(window.document.cookie, "tpId"),
    bindId = GetSingleCookie(window.document.cookie, "bind")
    ;
  // FLAG => 页面级别
  let match = false;

  // USER => 接口级别
  let user = false;

  // IS_CLIENT && WHITE
  if (isClient()) {
    _AuthList.map((data, index) => {
      if (window.location.pathname.match(new RegExp(data))) {
        match = true;
      }
    });
  }

  // 当前接口公共页面 但是必须有Token 才能够被访问
  if (ajaxOptions) {
    _AuthUser.map((data, index) => {
      if (ajaxOptions.url.indexOf(data) > -1) {
        user = true;
      }
    });
  }

  if ((json && json.jQueryStatus && json.jQueryStatus.status === 429) || json.status === 429) {
    AuthRedirectV2(window.location);
  }

  if (json && json.jQueryStatus && json.jQueryStatus.status === 423) {
    globalToast(JSON.parse(json.errResponseText));
  }
  if (!match && !user) {
    return json;
  }

  // jQuery 接口 || nodeFetch 接口 401 Token 过期逻辑
  if ((json && json.jQueryStatus && json.jQueryStatus.status === 401 && !tpId && !bindId) || json.status === 401 && !tpId && !bindId) {
    //AuthRedirect(window.location);
  }

  // 安全类页面没有Token
  if (_AuthList.indexOf(_PathName) > -1 && !_Token && !tpId && !bindId) {
    AuthRedirect(window.location);
  }
  return json;
}

export function AuthRedirect(WL) {
  const tpId = GetSingleCookie(window.document.cookie, "tpId"),
    bindId = GetSingleCookie(window.document.cookie, "bindId");
  const wl1 = WL.href;


  // WL.href = `/login?historyLocation=${encodeURI((WL.pathname).replace('/', ''))}`;
  // WL.href = `/login?historyLocation=${encodeURI((WL.pathname).replace('/', '') + (WL.search))}`;
  if ((wl1.indexOf('cart') == -1
    && wl1.indexOf('myAccount') == -1)) {
    WL.href = `/login?historyLocation=${WL.pathname.replace("/", "") + WL.search}`;
  } else {
    if ((tpId == null || tpId === '')
      && (bindId == null || bindId === '')) {
      WL.href = `/login?historyLocation=${WL.pathname.replace("/", "") + WL.search}`;
    }
  }
}

export function AuthRedirectV2(WL) {
  if (!WL.pathname.includes("v2/html/currentLimiting.html")) {
    WL.href = `/v2/html/currentLimiting.html?historyLocation=${WL.pathname.replace("/", "") + WL.search
      }`;
  }
}

/*which status err*/
export function ResolveStatusBug(statusNumber, documentName, apiName) {
  if (statusNumber && statusNumber == 1) {
    console.log(`action下的文件:${documentName}的${apiName}接口返回status为1`);
    return false;
  }
}

/*360*/
export function send360(parameters, parameters2) {
  if (window && window._qha) {
    if (typeof window._qha === "function") {
      window._qha(parameters, parameters2);
    } else {
      (window._qha.c = window._qha.c || []).push(parameters, parameters2);
    }
  }
}

/*
 * Get style by dom or class
 */
export function getStyle(selector, style) {
  if (!style) return;

  if (window && document && window.getComputedStyle && document.querySelector) {
    if (typeof selector === "string") {
      return window.getComputedStyle(document.querySelector(selector))[style];
    } else {
      return window.getComputedStyle(selector)[style];
    }
  }
}

/**
 * @Function 是否是要做逻辑的页面
 * @param {Object} regExp 正则表达式
 */
export function isDesiredPage(regExp) {
  if (typeof window == "undefined") return;
  return regExp.test(window.location.pathname);
}

/**
 *@Function preloadImages 图片预加载
 *@param {array} images 图片数组
 *@return {object} object.done是一个函数,链式调用,done方法接受一个函数参数,[func]非必需
 */
export const preloadImages = (images) => {
  if (!(images instanceof Array)) return;
  let count = 0,
    doSomething; // 加载完成后执行的函数
  for (var i = 0; i < images.length; i++) {
    let oImg = new Image();
    oImg.src = images[i];
    // 不管加载成功与否
    oImg.onload = checkStatus;
    oImg.onerror = checkStatus;
  }
  function checkStatus() {
    count++;
    if (count >= images.length) doSomething && doSomething();
  }
  return {
    done: function (func) {
      doSomething = func;
    },
  };
};

/**
 * @Function isArray 是否是数组
 * @param {*} obj 数据
 */
function isArray(obj) {
  return Object.prototype.toString.call(obj) == "[object Array]";
}

/**
 * @Function deepFreeze 深度冻结( 只冻结实例自身属性 ) 对象 || 数组
 * @param {Array|Object} obj 要冻结的数组或者对象
 * [ { a:{ e: 111 },b:[ { f:222 }, { g: 333} ] },{ c:{ h: 444 } } ]
 * { a:{ e: 111 },b:[ { f:222 }, { g: 333 } ] }
 * [ 0,1,2,3,4,5 ]
 */

export function deepFreeze(obj) {
  Object.freeze(obj); // 对象属性 数据值属性 和 访问器属性  都不可更改

  for (let property in obj) {
    if (!obj.hasOwnProperty(property) && !typeof obj != "object") continue;

    deepFreeze(obj[property]);
  }
}

/**
 * @Function deepClone 深度克隆( 只克隆实例自身属性 ) 对象 || 数组
 * @param {Array|Object} obj 要深拷贝的数据  对象 || 数组
 */
export function deepClone(obj) {
  let temp = new obj.constructor();

  for (let property in obj) {
    if (obj.hasOwnProperty(property)) {
      if (typeof obj[property] != "object") {
        temp[property] = obj[property];

        continue;
      }

      temp[property] = deepClone(obj[property]);
    }
  }

  return temp;
}

/**
 * @Function getQueryStringValue 获取url参数
 * @param {string} key url参数名
 */
export function getQueryStringValue(key) {
  return decodeURIComponent(
    window.location.search.replace(
      new RegExp(
        "^(?:.*[&\\?]" +
        encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") +
        "(?:\\=([^&]*))?)?.*$",
        "i",
      ),
      "$1",
    ),
  );
}



// WEBPACK FOOTER //
// ./common/lib/Tools.js